import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { AuthService } from "../core/services/auth.service";
import { UserService } from "../core/services/user-service.service";
import { Subscription } from "rxjs";
import { ComponentVisibilityService } from "../core/services/component-visibility.service";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent implements OnInit, OnDestroy {
  isLandingPage = false;
  isLoggedIn = false;
  showHeaderFooter = true;
  private authSubscription: Subscription | null = null;
  private visibilitySubscription: Subscription | null = null;
  private creditsSubscription: Subscription | null = null;
  credits: number = 0;
  userDetails: any = null;

  constructor(
    private router: Router,
    private authService: AuthService,
    private userService: UserService,
    private componentVisibilityService: ComponentVisibilityService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.isLandingPage = event.url === "/" || event.url === "/home";
      });
  }

  ngAfterViewInit(): void {
    this.userDetails = this.userService.getUserDetails();
  }
  get userInitial(): string {
    return this.userDetails?.name?.charAt(0) ?? "";
  }

  ngOnInit(): void {
    // Initialize the login state from auth service
    this.isLoggedIn = this.authService.checkAuthState();

    // Subscribe to the auth state changes
    this.authSubscription = this.authService.isLoggedIn$.subscribe(
      (isLoggedIn) => {
        this.isLoggedIn = isLoggedIn;
        if (!isLoggedIn) {
          this.credits = 0;
        }
      }
    );

    // Subscribe to user credits for real-time updates
    this.creditsSubscription = this.userService.userCredits$.subscribe(
      (credits) => {
        this.credits = credits;
      }
    );

    // Subscribe to header/footer visibility changes
    this.visibilitySubscription =
      this.componentVisibilityService.showHeaderFooter$.subscribe((show) => {
        this.showHeaderFooter = show;
      });
  }

  ngOnDestroy(): void {
    // Clean up subscriptions to avoid memory leaks
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
    if (this.visibilitySubscription) {
      this.visibilitySubscription.unsubscribe();
    }
    if (this.creditsSubscription) {
      this.creditsSubscription.unsubscribe();
    }
  }

  /**
   * Close mobile header when user clicks on any link
   */
  closeMobileHeader(): void {
    // Find the navbar collapse element and remove 'show' class
    const navbarCollapse = document.getElementById("navbarSupportedContent");
    if (navbarCollapse && navbarCollapse.classList.contains("show")) {
      navbarCollapse.classList.remove("show");
    }

    // Also remove the 'show' class from the navbar toggler button
    const navbarToggler = document.querySelector(".navbar-toggler");
    if (navbarToggler) {
      navbarToggler.setAttribute("aria-expanded", "false");
    }
  }
  logout(): void {
    this.closeMobileHeader();
    this.authService.logout().subscribe((res: any) => {
      if (res.success) {
        this.router.navigate(["/"]);
      }
    });
  }
}
